import React from "react";
import { Link, useLocation } from "react-router-dom";

const Inventory = () => {
  const location = useLocation();

  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname.startsWith(to);
    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}
        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem(
        "/inventory/incoming",
        "Pemasukan Barang",
        " flaticon-folder-2 "
      )}

      {renderNavItem(
        "/inventory/pembongkaran",
        "Pembongkaran",
        "flaticon-list-1 "
      )}

      {renderNavItem(
        "/inventory/outgoing",
        "Pengeluaran",
        "flaticon-folder-3 "
      )}

      {renderNavItem(
        "/inventory/pemuatan",
        "Pemuatan",
        "flaticon-truck "
      )}

      {renderNavItem(
        "/inventory/pemusnahan",
        "Pemusnahan",
        "flaticon-list-1 "
      )}
    </>
  );
};

export default Inventory;
